import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/** 平台 Tab 占位数量：TikTok / Meta / Google */
const PLATFORM_TAB_COUNT = 3;

/**
 * 账户管理页面骨架。
 *
 * 真实结构：`w-full h-full flex flex-col gap-4`
 * → 工具栏（左：平台 Tab 胶囊组 `w-53.25 p-1.25`；右：同步数据 / 绑定账户）
 * → `flex-1` 内的 `TableCardLayout`（带层级 Tab 头，广告账户 Tab 为 10 列）。
 */
export function AccountManagementSkeleton() {
  return (
    <div className="w-full h-full flex flex-col gap-4">
      {/* 平台切换 + 同步数据 / 绑定账户 */}
      <div className="flex items-center justify-between">
        {/* 胶囊组内 Tab 需要比容器底色更深 + 留间距，否则同色会连成一片看不见 */}
        <div className="flex h-auto w-53.25 items-center gap-1 rounded-md bg-[#F1F5F9] dark:bg-[#171717] p-1.25">
          {Array.from({ length: PLATFORM_TAB_COUNT }, (_, index) => (
            <Skeleton key={index} className="h-8 flex-1 rounded-sm bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
          ))}
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-24" />
        </div>
      </div>

      {/* 账户列表卡片（广告账户 Tab 为 11 列：勾选 + 广告账户ID/广告账户名称/TikTok账户/主体/标签/授权状态/账户状态/账户余额/近7日消耗/最近同步时间） */}
      <div className="min-h-0 flex-1 overflow-hidden">
        <ListPageSkeleton withHeaderTabs columnCount={11} />
      </div>
    </div>
  );
}

export default AccountManagementSkeleton;
